import React from 'react';
import { Badge, Button, Card } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';

interface AccommodationImageProps {
  HandleImageEdit: (Id: string) => void;
  HandleImageRemove: (Id: string) => void;
  HandleImageClick: (
    ImageNumber: number,
    ImageSrc: string,
    ImageDescription: string,
  ) => void;
  HandleItemReorder: (OldNumber: number, NewNumber: number) => void;
  ImageId: string;
  ImageNumber: number;
  ImageSrc: string;
  ImageText?: string;
  ImageDescription?: string;
  TotalImages: number;
  showEdit: boolean;
  showDelete: boolean;
  disabled: boolean;
}
const AccommodationImage = ({
  HandleImageEdit,
  HandleImageRemove,
  HandleImageClick,
  HandleItemReorder,
  ImageId,
  ImageNumber,
  ImageSrc,
  ImageText = '',
  ImageDescription = '',
  TotalImages,
  showEdit,
  showDelete,
  disabled,
}: AccommodationImageProps) => {
  const HandleOpenImage = (
    Event: React.MouseEvent<HTMLAnchorElement>,
    ImageSrcString: string,
  ) => {
    Event.preventDefault();
    HandleImageClick(ImageNumber, ImageSrcString, ImageDescription);
  };
  return (
    <Card className="bg-white border">
      <div className="position-relative">
        <Badge
          bg="gray-600"
          className="position-absolute top-0 start-0 m-8"
          style={{ zIndex: 1 }}
        >
          {ImageNumber} / {TotalImages}
        </Badge>
        <a href={ImageSrc} onClick={e => HandleOpenImage(e, ImageSrc)}>
          <img
            src={ImageSrc}
            alt=""
            className="w-100 rounded-top"
            style={{ aspectRatio: '3 / 2', objectFit: 'cover' }}
            onError={e => {
              e.currentTarget.src = '/placeholder.png';
            }}
          />
        </a>
      </div>
      <Card.Body className="p-8">
        {ImageText !== '' && (
          <p className="body-small text-truncate mb-4" title={ImageText}>
            {ImageText}
          </p>
        )}
        {ImageDescription !== '' && (
          <p className="body-small text-truncate mb-8" title={ImageDescription}>
            {ImageDescription}
          </p>
        )}
        <div className="d-flex justify-content-end gap-4">
          <Button
            className="border-0 px-8"
            size="sm"
            disabled={disabled || ImageNumber === 1}
            onClick={() => HandleItemReorder(ImageNumber, ImageNumber - 1)}
            title="Siirrä ylös"
            variant="outline-blue"
          >
            <Icon Name="caret-left-fill" />
          </Button>
          <Button
            className="border-0 px-8"
            size="sm"
            disabled={disabled || ImageNumber === TotalImages}
            onClick={() => HandleItemReorder(ImageNumber, ImageNumber + 1)}
            title="Siirrä alas"
            variant="outline-blue"
          >
            <Icon Name="caret-right-fill" />
          </Button>
          {showEdit && (
            <Button
              className="px-8"
              size="sm"
              onClick={() => HandleImageEdit(ImageId)}
              title="Muokkaa"
              variant="outline-blue"
            >
              <Icon Name="pencil-fill" />
            </Button>
          )}
          {showDelete && (
            <Button
              className="px-8"
              size="sm"
              onClick={() => HandleImageRemove(ImageId)}
              title="Poista"
              variant="outline-secondary"
            >
              <Icon Name="trash-fill" />
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
export default AccommodationImage;
export { AccommodationImage };
export type { AccommodationImageProps };
